export default __webpack_public_path__ + "static/media/ban-Acedol-Tabletbk.64fcf882.jpg";